'use client';

import { useEffect } from 'react';
import { gtmPushEvent } from '@kavak/frontend-layout';
import {
  setDeviceType,
  setUserHashes,
} from '@frontend-tools/utils/tracking/tracking';

interface TrackPageviewProps {
  userId?: string;
  userEmail?: string;
  userPhone?: string;
  /** `desktop` | `mobile` | `webview`, del header `x-device-type`. */
  deviceType?: string;
}

export function TrackPageview({
  userId,
  userEmail,
  userPhone,
  deviceType,
}: TrackPageviewProps) {
  useEffect(() => {
    setUserHashes(userEmail, userPhone);
    setDeviceType(deviceType);

    try {
      gtmPushEvent({
        track: {
          event: 'pageview',
          userId,
          userEmail,
          userPhone,
          path: window.location.pathname,
        },
        debug: false,
      });
    } catch (error) {
      console.error('Failed to push pageview to GTM:', error);
    }
  }, []);

  return null;
}
